import { render, staticRenderFns } from "./BooksPurchasesRequests.vue?vue&type=template&id=c71dc52c&"
import script from "./BooksPurchasesRequests.vue?vue&type=script&lang=js&"
export * from "./BooksPurchasesRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports